import { useNodeId } from "@xyflow/react";
import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import { Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { CREATE_NEW_ZAP_BUTTON_TEXT } from "@zapier/canvas-constants";
import {
  createNewZapSetter,
  createNotificationSetter,
  isCreatingZewZapAtom,
} from "@zapier/canvas-state";
import { useEmitResourceCreatedEvents } from "../../hooks/useEmitResourceCreatedEvents";

import useUpdateNode from "../../hooks/useUpdateNode";

export function CreateNewZapButton() {
  const nodeId = useNodeId();
  const updateNodeAndSave = useUpdateNode();
  const createNotification = useSetAtom(createNotificationSetter);
  const { emitEventOnZapCreation } = useEmitResourceCreatedEvents();
  const isLoading = useAtomValue(isCreatingZewZapAtom);
  const createNewZap = useSetAtom(createNewZapSetter);

  const handleCreateNewZap = useCallback(async () => {
    await createNewZap({
      nodeId,
      updateNodeAndSave,
      createNotification,
      emitEventOnZapCreation,
    });
  }, [
    nodeId,
    createNewZap,
    updateNodeAndSave,
    createNotification,
    emitEventOnZapCreation,
  ]);

  return (
    <Button
      variant="primary"
      size="compact"
      iconPosition="start"
      isPending={isLoading}
      onPress={handleCreateNewZap}
    >
      <Icon name="formAdd" />
      {CREATE_NEW_ZAP_BUTTON_TEXT}
    </Button>
  );
}
